export default __webpack_public_path__ + "static/media/watch-later.8fbd972e.svg";